module.exports = __webpack_public_path__ + "pc/img/swiper_04.8496bfeb.jpg";